export const environment = {
    production: false,
    // Relative URLs: ng serve proxy forwards /api to the remote backend (avoids CORS).
    domain: '/api/v1/',
    base_url: '/',
    enableSignalR: true
};
